import { Capitalize, ia } from 'lib/helpers/utility';
import { serviceTypes } from 'lib/constants/constants';

export const renderType = ({ primary, secondary, tertiary } = {}) => {
  const typeMap = { primary: 'Primary', secondary: 'Secondary', tertiary: 'Tertiary' };

  return (
    Object.entries({ primary, secondary, tertiary })
      .filter(([_, value]) => ia(value))
      .map(([key]) => typeMap[key])
      .join(', ') || '-'
  );
};

export const renderItemType = (item) => {
  if (!item) return '';

  // Primary type
  if (item?.primary) {
    return renderType(item);
  }

  // If item is from a package
  if (item?.packageId) {
    return 'Service from package';
  }

  // If item is a package
  if (item?.procedures || item?.products) {
    return 'Package';
  }

  const itemType = item?.type;
  // A service's charge type wins over the quantity/sales_count heuristic: services sold from the
  // payment screen carry both counts too.
  const matchedType = serviceTypes?.find((p) => p?.value === itemType);

  if (matchedType?.label) {
    return matchedType.label;
  }

  if (item?.quantity && item?.sales_count) {
    return 'Product';
  }

  // Default formatting
  return Capitalize((itemType || '').replace(/_/g, ' '));
};
